<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">{{ cafeName }} 카페의 상세정보</div>
                    <div class="tab_content">
                            <cafe-write-component :cafe-key="cafeKey" :cafe-type="`requestUpdate`"></cafe-write-component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "@/utils/event-bus";
    import CafeWriteComponent from "@/components/justcafe/CafeWriteComponent";
    export default {
        name: 'OpenRequestCafeDetail',
        components: {
            CafeWriteComponent
        },
        mixins: [  ],
        data() {
            return{
                cafeKey: this.$route.params.c_idx,
                cafeName:''
            }
        },
        mounted() {
            EventBus.$on('CafeDetailSetData',this.setData)
        },
        beforeDestroy() {
            EventBus.$off('CafeDetailSetData')
        },
        watch: {
        },
        created() {
        },
        methods: {

            setData(key,value){
                this[key] = value
            },
            save() {
                EventBus.$emit('writeCafe')
            },
        }
    }
</script>
